export type BackendResponse<T> = {
    data: T
    status: number
    serverTime: number
}

export const enum Status {
    //resolved
    COMPLETED = 'COMPLETED',
    //invalid-state
    //api-fail
    EXPIRED = 'EXPIRED',
    //rejected
    CANCELED = 'CANCELED',
    FAILED = 'FAILED',
    //idle
    CANCELLATION_ATTEMPTED = 'CANCELLATION_ATTEMPTED',
    CANCELLATION_FAILED = 'CANCELLATION_FAILED',
    PROCESSING = 'PROCESSING',
}

export type ListItem = { name: string; value: string }

export type GetMainDataResponse = {
    qr_id: string
    merchant_title: string
    merchant_logo: Maybe<string>
    merchant_fav: string
    order_id: Maybe<string>
    status?: Maybe<Status>
    comment: string
    amount: string
    expires_at: Maybe<string>
    created_at: Maybe<string>
    // true - динамическая ссылка; false - статичная ссылка
    one_time: boolean
    options: Maybe<{
        redirectLink: Maybe<string>
        autoRedirect: boolean
        removeHeader: boolean
        elements: Maybe<ListItem[]>
    }>
}

export const enum BankName {
    NAMBA_ONE = 'NAMBA_ONE',
    ELCART = 'ELCART',
    MBANK = 'MBANK',
    RSK_24 = 'RSK_24',
    DEMIR_BANK = 'DEMIR_BANK',
    ELCOM = 'ELCOM',
    BAKAI = 'BAKAI',
    KOMPANION = 'KOMPANION',
    OPTIMA = 'OPTIMA',
    AIYL = 'AIYL',
    FINCA = 'FINCA',
    BALANCE = 'BALANCE',
    KKB = 'KKB',
    KSB = 'KSB',
    MEGAPAY = 'MEGAPAY',
    MBULAK = 'MBULAK',
    ODENGI = 'ODENGI',
    SIMBA = 'SIMBA',
    ELDIK = 'ELDIK',
    KICB = 'KICB',
}

export type SendBankClickResponse = {
    status: 'ok'
}

export type SendBankClickParams = {
    link: string
    bankName: BankName
}

export type SendAppDataParams = {
    deviceId?: string
    sessionId?: string
    createdAt?: string
    link?: string
    data?: Maybe<Record<string, unknown>>
}

export type SendAppDataResponse = {
    status: 'ok'
}

export type SendAppEventParams = {
    deviceId?: string
    sessionId?: string
    createdAt?: string
    link?: string
    data?: Maybe<{
        name?: 'scroll' | 'touch' | 'click' | 'bankClick'
        bank?: {
            name: string
            link: string
        }
    }>
}

export type SendAppEventResponse = {
    status: 'ok'
}

export type Api = {
    getMainData: (
        token: string
    ) => Promise<BackendResponse<GetMainDataResponse>>
    sendBankClick: (
        params: SendBankClickParams
    ) => Promise<BackendResponse<SendBankClickResponse>>
    sendAppData: (
        params: SendAppDataParams
    ) => Promise<BackendResponse<SendAppDataResponse>>
    sendAppEvent: (
        params: SendAppEventParams
    ) => Promise<BackendResponse<SendAppEventResponse>>
}
